import React, { useEffect } from "react";
import "../../css/Pay.css";
import { useDispatch, useSelector, UseSelector } from "react-redux";
import { fetchAsyncPay, PayUpdatedTime } from "./PaySlice";
import { PayInfo } from "./PaySlice";
import TotalAll from "./total/TotalAll";
import TotalRide from "./total/TotalRide";
import TotalPaid from "./total/TotalPaid";
import MonthAll from "./month/MonthAll";
import MonthRide from "./month/MonthRide";
import MonthPaid from "./month/MonthPaid";
import MonthTransPay from "./month/MonthTransPay";
import WeekLinePay from "./week/WeekLinePay";
import YearAll from "./year/YearAll";
import YearRide from "./year/YearRide";
import YearPaid from "./year/YearPaid";

const Pay = () => {
  const PayInfoData = useSelector(PayInfo);

  const dispatch = useDispatch();

  const payUpdatedTime = useSelector(PayUpdatedTime);

  useEffect(() => {
    // 初回描画時に実行する処理
    dispatch(fetchAsyncPay());

    // 定期実行を設定
    const interval = setInterval(() => {
      dispatch(fetchAsyncPay());
    }, 60000); // 60秒ごとに実行

    // コンポーネントのクリーンアップ時にインターバルをクリア
    return () => clearInterval(interval);
  }, [dispatch]); // 依存配列にdispatchを含める

  return (
    <div className="position_row">
      <div className="dashboard_container_pay">
        <h1 className="dashboard_title_pay">利用状況 -乗車金額-</h1>
        <div className="time_msg">※データは1分ごとに自動更新されます</div>
        <div className="dashbaord_time">最終更新時間 : {payUpdatedTime}</div>
        {PayInfoData && (
          <>
            <div className="desc_container">
              <div className="ride">ライド金額 : ユーザが利用した金額</div>
              <div className="use">乗車金額 : クーポンを割引した、利用発生金額</div>
              <div className="pay">支払金額 : ユーザが支払いをした金額</div>
            </div>
            <div className="graph_container_pay">
              <div className="paid_box_container">
                <TotalAll TotalAll={PayInfoData!.total["total"]} />
                <TotalRide TotalRide={PayInfoData!.total["ride"]} />
                <TotalPaid TotalPaid={PayInfoData!.total["paid"]} />
              </div>
              <div className="paid_box_container">
                <YearAll YearAll={PayInfoData!.this_year["total"]} />
                <YearRide YearRide={PayInfoData!.this_year["ride"]} />
                <YearPaid YearPaid={PayInfoData!.this_year["paid"]} />
              </div>
              <div className="paid_box_container_second">
                <MonthAll
                  ThisMonth={PayInfoData!.this_month["total"]}
                  LastMonth={PayInfoData!.last_month["total"]}
                />
                <MonthRide
                  ThisMonth={PayInfoData!.this_month["ride"]}
                  LastMonth={PayInfoData!.last_month["ride"]}
                />
                <MonthPaid
                  ThisMonth={PayInfoData!.this_month["paid"]}
                  LastMonth={PayInfoData!.last_month["paid"]}
                />
              </div>
              <MonthTransPay MonthTransPay={PayInfoData!.month_fee} />
              <WeekLinePay />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Pay;
